@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

$text-color: #019990;

.demurrageLink {
  background: v.$palette-teal-light;
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 10px 16px;

  .icon {
    width: 20px;
    height: 20px;
  }

  .iconWrapper {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }

  .text {
    margin-right: 5px;
    background: $text-color;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  a {
    margin-left: auto;

    padding: 0;
    border: none;
    outline: none;
    appearance: none;
    cursor: pointer;
    background: transparent;
    &::-moz-focus-inner {
      border: 0;
    }

    text-decoration: underline;
    color: $text-color;
  }

  .button,
  .text {
    @include t.text(14px, 22px, 500);
  }
}
